var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import paths from "../../../app/paths";
import { env } from "../../../definitions/global.vars";
export default function Shortcuts() {
    var navigate = useNavigate();
    return (_jsxs("div", __assign({ className: "shortcuts" }, { children: [env.vrgames && env.pushtowin && (_jsxs("div", __assign({ className: "shortcuts-row" }, { children: [_jsx("div", __assign({ className: "shortcuts-item", onClick: function () { return navigate(paths.VRGAMES); } }, { children: _jsx("img", { src: "https://cdn.oley.com/images/web-sanaloyunlar.jpg", alt: "sanal-oyunlar" }, void 0) }), void 0), _jsx("div", __assign({ className: "shortcuts-item", onClick: function () { return navigate(paths.PUSHWIN); } }, { children: _jsx("img", { src: "https://cdn.oley.com/images/web-baskazan.jpg", alt: "bas-kazan" }, void 0) }), void 0)] }), void 0)), _jsx("div", __assign({ className: "shortcuts-row" }, { children: _jsx("div", __assign({ className: "shortcuts-item", onClick: function () { return navigate(paths.TJK); } }, { children: _jsx("img", { src: "https://cdn.oley.com/images/web-atyarisi.jpg", alt: "at-yarisi" }, void 0) }), void 0) }), void 0)] }), void 0));
}
